<form [formGroup]="editUserAccessForm" (ngSubmit) = "onSubmit()">
    <p-dialog  [(visible)]="displayDialog" 
      [modal]="true" 
      [positionTop]="50" 
      [maximizable]="true"
      [contentStyle]="{'min-width':'500px','min-height':'300px'}"
      (onHide)="dialogClose()"
      >
      <p-header>
        <b>Edit User Access</b>
      </p-header>
        <div class="ui-grid ui-grid-responsive formcontainer">
          <div formGroupName="Relationship">
            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="Relationship">Partnership<span class="custom-required">*</span></label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 link-row">
                    <app-partnership-dropdown 
                      [relationship]="relationship" 
                      defaultLabel="Select Partnership"
                      [maxSelectedLabels]="1" 
                      filterPlaceHolder=""
                      formControlName="Relationship"
                      (onChange)="partnershipChange($event)"
                      readOnly="readOnly">
                    </app-partnership-dropdown>
                    <i (mouseover)="displaySelectedItems(op1, $event, 'Relationship')"
                     (mouseout)="op1.hide($event)">
                     <span [ngClass]="{'check-circle-gray': relationshipControl.invalid,
                                       'check-circle-green': !relationshipControl.invalid}">
                       <i class="pi pi-check-circle"></i>
                     </span>
                    </i>
                </div>
              </div>
            </div>
            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    <label for="Relationship">Asset Group<span class="custom-required">*</span></label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 link-row">
                    <app-asset-group-dropdown
                      [relationshipDataGroupSelected]="relationshipDataGroup" 
                      [relationship]="relationship"
                      [maxSelectedLabels]="1"
                      [group]=true
                      defaultLabel="Select Asset Group" 
                      filterPlaceHolder=""
                      formControlName="RelationshipDataGroup"
                      (onChange)="assetGroupChange($event)"
                      *ngIf="relationship">
                    </app-asset-group-dropdown>
                    <i (mouseover)="displaySelectedItems(op2, $event, 'RelationshipDataGroup')" 
                      (mouseout)="op2.hide($event)">
                      <span [ngClass]="{'check-circle-gray': relationshipDataGroupControl.invalid,
                                        'check-circle-green': !relationshipDataGroupControl.invalid}">
                        <i class="pi pi-check-circle"></i>
                      </span>
                    </i>
                </div>
              </div>
            </div>
            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label for="CanAddUser" class="" >Privileges<span class="custom-required">*</span></label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 link-row">
                  <app-privilege-group-dropdown
                    [privilegeGroup]="privilegeGroup"
                    [privilegeGroupSelected] ="userPrivilegeGroupSelected"
                    [maxSelectedLabels]="1"
                    defaultLabel="Select Privilege Group" 
                    filterPlaceHolder=""
                    formControlName = "PrivilegeGroup"
                    (onChange) = "onPrivilegeGroupChange($event)"
                  > 
                  </app-privilege-group-dropdown>
                  <i (mouseover)="displaySelectedItems(op4, $event, 'PrivilegeGroup')" 
                    (mouseout)="op4.hide($event)">
                    <span [ngClass]="{'check-circle-gray': (privilegeGroupControl.invalid || privilegeGroupSelected.length === undefined
                                                           || privilegeGroupSelected.length <= 0),
                                      'check-circle-green': privilegeGroupSelected.length }"> 
                      <i class="pi pi-check-circle"></i>
                    </span>
                  </i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <app-privilege-dropdown 
                      [privilegeGroup] = "relationshipPrivilege"
                      [preSelectedPrivilege] = "userPrivilegeSelected"                      
                      formControlName = "Privilege"
                      (onChange) = "privilegeChange($event)"
                      [maxSelectedLabels]="1"
                      [group]=true
                      defaultLabel="Select Privilege" 
                      filterPlaceHolder="">
                    </app-privilege-dropdown>
                    <i (mouseover)="displaySelectedItems(op3, $event, 'Privileges')" 
                      (mouseout)="op3.hide($event)">
                      <span [ngClass]="{'check-circle-gray': (privilegeControl.invalid  || privilegesSelected.length === undefined 
                                                                          || privilegesSelected.length <= 0 ),
                                      'check-circle-green': (!privilegeControl.invalid && privilegesSelected.length !== undefined 
                                                                          && privilegesSelected.length)}">
                        <i class="pi pi-check-circle"></i>
                      </span>
                    </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      <p-footer>
          <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
          <button pButton type="submit" label="{{processing ? 'Processing' : 'Update Access'}}"
           [disabled]="processing || editUserAccessForm.invalid"></button>
      </p-footer>
    </p-dialog>
  </form>
  <p-overlayPanel #op1 [dismissable]="true" class="no-flicker">
    <ul>
      <li *ngFor="let item of displayItems">{{item}}</li>
    </ul>
  </p-overlayPanel>
  <p-overlayPanel #op2 [dismissable]="true" class="no-flicker">
    <div *ngFor="let rel of displayItems">
      <ul>
        <li>
          <b>{{rel.RelationshipName}}</b>
          <ul>
            <li *ngFor="let group of assetGroupByRelationhipId(rel.Id)">{{group.RelationshipGroupName}}</li>
          </ul>
        </li>
      </ul>
    </div>
  </p-overlayPanel>
  <p-overlayPanel #op3 [dismissable]="true" class="no-flicker">
    <div *ngFor="let group of displayItems">
      <ul>
        <li>
          <b>{{group.Key}}</b>
          <ul>
            <li *ngFor="let privilege of group.Privilege">{{privilege.PrivilegeName}}</li>
          </ul>
        </li>
      </ul>
    </div> 
  </p-overlayPanel>
  <p-overlayPanel #op4 [dismissable]="true" class="no-flicker">
    <div *ngFor="let group of displayItems">
      <ul>
        <li>
          <b>{{group.GroupName}}</b>
          <ul>
            <li *ngFor="let privilege of group.Privileges">{{privilege.PrivilegeName}}</li>
          </ul>
        </li>
      </ul>
    </div> 
  </p-overlayPanel>